<template>
  <div class="py-4 container-fluid">
    <div class="d-sm-flex jmy-auto mt-4 ms-auto mt-lg-0">
        <div class="my-auto ms-auto">
          <button type="button" data-bs-toggle="modal" data-bs-target="#packageModal" class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 ">
            Nuevo Embalaje
          </button>     
        </div>
    </div> 
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
            <div class="table-responsive p-4">
              <full-table v-if="!!packagesData" :items="packagesData.items" :pagination="pagination"
                :headers="headers" @changed-page="paginationPageChange" @row-change="paginationRowChange"
                @header-change="onHeaderChange" @search-change="onSearchChange" @reload-clicked="getPackages">
                <template #row="packing">
                  <td class="font-weight-bold">
                    <span class="my-2 text-xs columns">{{packing.name}}</span>
                  </td>
                  <td class="font-weight-bold text-end">
                    <span class="my-2 text-xs columns">{{packing.high}}</span>
                  </td>
                  <td class="font-weight-bold text-end">
                    <span class="my-2 text-xs columns">{{packing.long}}</span>
                  </td>
                  <td class="font-weight-bold text-end">
                    <span class="my-2 text-xs columns">{{packing.width}}</span>
                  </td>
                  <td class="text-center text-sm" style="width: 10rem" >
                    <a class="mx-3" 
                        title="Eliminar"
                        style="cursor:pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#deletePackageModal"
                        @click="packageToDelete = { ...packing} ">
                        <i class="fas fa-trash text-secondary"></i>
                    </a>  
                  </td>
                </template>
              </full-table>
            </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
    <new-package  ref="thisModal" @new-package="onNewPackage"></new-package>
    <Modal-delete-confirmation :entity='packageToDelete' @confirm-delete="deletePackage" />
  </div>

</template>

<script>
import { FullTable } from "@/hotaka/components";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import NewPackage from "./components/NewPackage.vue";
import ModalDeleteConfirmation from "./components/ModalDeleteConfirmation.vue";
export default {
  name: "PackagesList",
  components: {
    FullTable,
    SoftSnackbar,
    NewPackage,
    ModalDeleteConfirmation
  },
  data()  {
    return{
      packageToDelete: null,
      pagination: {
        total: 0,
        rows: 10,
        currentPage: 1,
        pages: {
          total: 10,
          current: 1
        },
        entries: [5, 10, 15, 20, 50]
      },
      headers:[
        {title:'Nombre',sort:{sorteable:true,order:""}, column: "name"},
        {title:'Alto',sort:{sorteable:false,order:""}, column: "high", class: "text-end"},
        {title:'Largo',sort:{sorteable:false,order:""}, column: "long", class: "text-end"},
        {title:'Ancho',sort:{sorteable:false,order:""}, column: "width", class: "text-end"},
        {title:'Acciones',sort:{sorteable:false,order:""}, class: "text-center"},
      ],
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
      filters:{
        search: '',
        sort:{
          sort:'',
          order:''
        }
      },
    }
  },
  computed: {
    packagesData() {
      return this.$store.state.package.list.data;
    },
    newPackageStatus(){
      return this.$store.state.package.newPackage.status;
    },
    deletePackageStatus(){
      return this.$store.state.package.deletePackage.status;
    }
  },
  watch: {
    packagesData() {
      if(this.packagesData){
        this.pagination.total= this.packagesData.total;
      }
    },
    newPackageStatus(newValue){
      if (newValue.created) {
        this.notificationInfo = {
          title: 'Genial!',
          message: 'Embalaje Creado',
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getPackages();
          }, 200);
      } else if (newValue.error) {
        let message="Ha ocurrido un error al crear el embalaje";
        const error= newValue.error.error;
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    },
    deletePackageStatus(value){
      if (value.deleted) {
        this.notificationInfo = {
          title: 'Genial!',
          message: 'Embalaje Eliminado',
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getPackages();
          }, 200);
      } else if (value.error) {
        let message="Ha ocurrido un error al crear el embalaje";
        const error= value.error.error;
        if (error) {
          message = error
        }
        this.notificationInfo = {
          title: 'Ups! Lo Sentimos',
          message: message,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      }
    }
  },
  mounted() {
    this.getPackages();
  },
  methods: {
    getPackages() {
      this.$store.commit("package/load",{pagination:this.pagination,filters: this.filters});
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
      },2700);
    },
    onSearchChange(value){
      this.pagination.currentPage = 1;
      this.filters.search=value;
      this.getPackages(); 
    },
    paginationPageChange(page) {
      this.pagination.currentPage = page;
      this.getPackages(); 
    },
    paginationRowChange(rows) {
      this.pagination.rows = rows;
      this.getPackages(); 
    },
    onHeaderChange(val){
      this.filters.sort={
        sort: val.column,
        order: val.order=='asc'? "ascending": "descending"
      }
      this.getPackages(); 
    },
    onNewPackage(value){
      if(value){
      this.$store.commit("package/sendnewPackage",value);
      }
    },
    deletePackage(packing){
      this.$store.commit("package/deletePackage",packing._id);
    },
    
  }
};
</script>
<style scoped>
.columns {
  max-width: 150px;
}
.image{
  height: 2.2rem !important;
  border-radius: 9%;
}

.overflow-column {
  overflow: hidden;
  text-overflow: ellipsis;
}

.pointer {
  cursor: pointer;
}
</style>
